import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityMontreuilPage() {
  const data = citiesData.find((c) => c.slug === "montreuil")!;
  return <CityPage data={data} />;
}
